import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/layout";
// import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const constantRoutes = [
//  {
//     path: "/",
//     component: Layout,
//     // redirect: "/home",   // 把 redirect 指向 /home，这样访问根域名就能自动跳到首页
//     children: [
//       {
//         path: "/",
//         component: () => import("@/views/index/index"),
//         name: "首页",
//         meta: { title: "首页", icon: "dashboard" },
//       },
//     ],
//   },
  {
    path: "/login",
    name: "登录",
    component: () => import("@/views/login/login")
  },
  {
    path: "/forgotPassword",
    name: "忘记密码",
    component: () => import("@/views/login/forgotPassword")
  },
  {
    path: "/register",
    name: "注册",
    component: () => import("@/views/login/register")
  },
  {
    path: "/login_myinfo",
    name: "登录-设置账号信息",
    component: () => import("@/views/login/login_myinfo")
  },
  {
    path: "/next_per",
    name: "登录-设置账号信息-个人信息",
    component: () => import("@/views/login/next_per")
  },
  {
    path: "/next_company",
    name: "登录-设置账号信息-企业信息",
    component: () => import("@/views/login/next_company")
  },
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "/",
        component: () => import("@/views/index/index"),
        name: "首页",
        meta: { title: "首页", icon: "dashboard" },
      },
    ],
  },
  // **************************行业资讯**********************************
  {
    path: "/information",
    redirect: '/information/index/0?',
    name: "资讯",
    component: Layout,
    children: [
      {
        path: "/information/index/:id",
        component: () => import("@/views/information/index"),
        name: "行业资讯",
        meta: { keepAlive: true }
      },
      {
        path: "/information/details",
        component: () => import("@/views/information/details"),
        name: "新闻详情",
      },
    ],
  },
  // **************************培训中心 **********************************
  {
    path: "/training",
    redirect: '/training/enlist',
    name: "培训中心",
    component: Layout,
    children: [
      {
        path: "/training/enlist",
        component: () => import("@/views/training/enlist"),
        name: "培训报名",
      },
      {
        path: "/training/enlistDetails",
        component: () => import("@/views/training/enlistDetails"),
        name: "培训报名详情",
      },
      {
        path: "/training/agency",
        component: () => import("@/views/training/agency"),
        name: "培训机构",
      },
      {
        path: "/training/agencyDetails",
        component: () => import("@/views/training/agencyDetails"),
        name: "培训机构详情",
      },
      {
        path: "/training/courseDetails",
        component: () => import("@/views/training/courseDetails"),
        name: "培训课程详情",
      },
      {
        path: "/training/article",
        component: () => import("@/views/training/article"),
        name: "培训文章",
      },
      {
        path: "/training/articleDetails",
        component: () => import("@/views/training/articleDetails"),
        name: "培训文章详情",
      },
      {
        path: "/training/video",
        component: () => import("@/views/training/video"),
        name: "培训视频",
      },
      {
        path: "/training/videoDetails",
        component: () => import("@/views/training/videoDetails"),
        name: "培训视频详情",
      },
    ],
  },
  // **************************咨询服务 **********************************
  {
    path: "/consulting",
    redirect: '/consulting/index',
    // name: " 咨询服务",    
    component: Layout,
    children: [
      {
        path: "/consulting/index",
        component: () => import("@/views/consulting/index"),
        meta: { title: " 咨询服务", icon: "dashboard" }
      },
      {
        path: "/consulting/complayList",
        component: () => import("@/views/consulting/complayList"),
        meta: { title: " 公司列表", icon: "dashboard" },
      },
      {
        path: "/consulting/complayDetail",
        component: () => import("@/views/consulting/complayDetail"),
        meta: { title: " 公司详情", icon: "dashboard" },
      },
      {
        path: "/consulting/details",
        component: () => import("@/views/consulting/details"),
        meta: { title: " 咨询服务详情", icon: "dashboard" },
      },
    ],
  },
  // **************************招聘大厅 **********************************
  {
    path: "/recruitment",
    redirect: '/recruitment/postList',
    name: " 招聘大厅",
    component: Layout,
    children: [
      {
        path: "/recruitment/postList",
        component: () => import("@/views/recruitment/postList"),
        name: "热招岗位",
      },
      {
        path: "/recruitment/postDetails",
        name: "岗位详情",
        component: () => import("@/views/recruitment/postDetails"),
      },
      {
        path: "/recruitment/enterpriseList",
        component: () => import("@/views/recruitment/enterpriseList"),
        name: "热门企业",
      },
      {
        path: "/recruitment/enterpriseDetails",
        component: () => import("@/views/recruitment/enterpriseDetails"),
        name: "企业详情",
      },
    ],
  },
  // **************************行业专家 **********************************
  {
    path: "/experts",
    redirect: '/experts/expertslist',
    name: "行业专家",
    component: Layout,
    children: [
      {
        path: "/experts/expertslist",
        component: () => import("@/views/experts/expertslist"),
        meta: { title: "专家列表", icon: "dashboard" },
      },
      {
        path: "/experts/expertsdetail",
        component: () => import("@/views/experts/expertsdetail"),
        meta: { title: "专家详情", icon: "dashboard" },
      },
      {
        path: "/experts/answering",
        component: () => import("@/views/experts/answering"),
        meta: { title: "问答列表", icon: "dashboard" },
      },
      {
        path: "/experts/answeringDetail",
        component: () => import("@/views/experts/answeringDetail"),
        meta: { title: "问答详情", icon: "dashboard" },
      },
    ],
  },
  // **************************业内商机 **********************************
  {
    path: "/opportunity",
    redirect: '/opportunity/tender',
    name: "业内商机",
    component: Layout,
    children: [
      {
        path: "/opportunity/tender",
        component: () => import("@/views/opportunity/tender"),
        meta: { title: "招投标信息", icon: "dashboard" },
      },
      {
        path: "/opportunity/tender/tenderDetails",
        component: () => import("@/views/opportunity/tenderDetails"),
        meta: { title: "招投标信息详情", icon: "dashboard" },
      },
      {
        path: "/opportunity/supply",
        component: () => import("@/views/opportunity/supply"),
        meta: { title: "设备供需", icon: "dashboard" },
      },
      {
        path: "/opportunity/tender/supplyDetails",
        component: () => import("@/views/opportunity/supplyDetails"),
        meta: { title: "设备供需详情", icon: "dashboard" },
      },
    ],
  },
  // **************************合作发展 **********************************
  {
    path: "/cooperate",
    name: "合作发展",
    component: Layout,
    children: [
      {
        path: "/cooperate",
        component: () => import("@/views/cooperate/index"),
        meta: { title: "合作发展", icon: "dashboard" },
      },
      {
        path: "/cooperate/details",
        component: () => import("@/views/cooperate/details"),
        meta: { title: "合作发展", icon: "dashboard" },
      },
    ],
  },
  // ************************** 企业中心 **********************************
  {
    path: "/enterpriseCenter",
    redirect: '/enterpriseCenter/index',
    name: " 企业中心",
    component: Layout,
    children: [
      {
        path: "/enterpriseCenter/index",
        redirect: '/enterpriseCenter/position',
        component: () => import("@/views/enterpriseCenter/index"),
        children: [
          {
            path: "/enterpriseCenter/myInfo",
            component: () => import("@/views/enterpriseCenter/myInfo"),
            name: "个人信息",
          },
          {
            path: "/enterpriseCenter/recruit",
            component: () => import("@/views/enterpriseCenter/recruitment"),
            name: "招聘中心",
          },
          {
            path: "/enterpriseCenter/talent",
            component: () => import("@/views/enterpriseCenter/talent"),
            name: "人才管理",
          },
          {
            path: "/enterpriseCenter/position",
            component: () => import("@/views/enterpriseCenter/position"),
            name: "职位管理",
          },
          {
            path: "/enterpriseCenter/publish",
            component: () => import("@/views/enterpriseCenter/publish"),
            name: "发布职位",
          },
          {
            path: "/enterpriseCenter/enterpriseCenter",
            component: () => import("@/views/enterpriseCenter/enterpriseCenter"),
            name: "企业中心",
          },
          {
            path: "/enterpriseCenter/communicate",
            component: () => import("@/views/enterpriseCenter/communicate"),
            name: "在线沟通",
            children: [
              {
                path: '/enterpriseCenter/chat/privatechat/:id',
                component: () => import("@/views/enterpriseCenter/chat/PrivateChat"),
                name: "聊天",
              },
            ]
          },
          {
            path: "/enterpriseCenter/message",
            component: () => import("@/views/enterpriseCenter/message"),
            name: "消息通知",
          },
          {
            path: "/enterpriseCenter/messageDetail",
            component: () => import("@/views/enterpriseCenter/messageDetail"),
            name: "消息详情",
          },
          {
            path: "/enterpriseCenter/binding",
            component: () => import("@/views/enterpriseCenter/binding"),
            name: "账号绑定",
          },
          {
            path: "/enterpriseCenter/updatePass",
            component: () => import("@/views/enterpriseCenter/updatePass"),
            name: "修改密码",
          },
        ],
      },

      {
        path: "/enterpriseCenter/curriculumVitaeDetail",
        component: () => import("@/views/enterpriseCenter/curriculumVitaeDetail"),
        name: "简历详情",
      },
    ],
  },
  // ************************** 个人中心 **********************************
  {
    path: "/personalCenter",
    redirect: '/personalCenter/index',
    name: " 个人中心",
    component: Layout,
    children: [
      {
        path: "/personalCenter/index",
        redirect: '/personalCenter/recommendPositions',
        component: () => import("@/views/personalCenter/index"),
        children: [
          {
            path: "/personalCenter/recommendPositions",
            component: () => import("@/views/personalCenter/recommendPositions"),
            name: "推荐职位",
          },
          {
            path: "/personalCenter/communicationProcess/:id",
            component: () => import("@/views/personalCenter/communicationProcess"),
            name: "沟通过程",
          },
          {
            path: "/personalCenter/favorites/:id",
            component: () => import("@/views/personalCenter/favorites"),
            name: "收藏夹",
          },
        ]
      },
      {
        path: "/personalCenter/personal/index",
        redirect: '/personalCenter/personal/binding',
        component: () => import("@/views/personalCenter/personal/index"),
        name: "个人中心",
        children: [
          {
            path: "/personalCenter/personal/binding",
            component: () => import("@/views/personalCenter/personal/binding"),
            name: "账号绑定"
          },
          {
            path: "/personalCenter/personal/authentication",
            component: () => import("@/views/personalCenter/personal/authentication"),
            name: "实名认证"
          },
          {
            path: "/personalCenter/personal/updatePass",
            component: () => import("@/views/personalCenter/personal/updatePass"),
            name: "修改密码"
          },
          {
            path: "/personalCenter/personal/privacy",
            component: () => import("@/views/personalCenter/personal/privacy"),
            name: "隐私设置"
          }
        ]
      },
      {
        path: "/personalCenter/myAnswering",
        component: () => import("@/views/personalCenter/myAnswering"),
        name: "我的问答",
      },
      {
        path: "/personalCenter/myAnswerDeatil",
        component: () => import("@/views/personalCenter/myAnswerDeatil"),
        name: "我的问答",
      },
      {
        path: "/personalCenter/signUp",
        component: () => import("@/views/personalCenter/signUp"),
        name: "报名管理",
      },
      {
        path: "/personalCenter/interviewDetail",
        component: () => import("@/views/personalCenter/interviewDetail"),
        name: "面试详情",
      },
      {
        path: "/personalCenter/onlineCommunication/:id",
        component: () => import("@/views/personalCenter/onlineCommunication"),
        name: "在线沟通",
        children: [
          {
            path: '/personalCenter/chat/privatechat/:id',
            component: () => import("@/views/personalCenter/chat/PrivateChat"),
            name: "聊天",
          },
        ]
      },
      {
        path: "/personalCenter/curriculumVitae",
        component: () => import("@/views/personalCenter/curriculumVitae"),
        name: "在线简历",
      },
      {
        path: "/personalCenter/curriculumVitaeEdit",
        component: () => import("@/views/personalCenter/curriculumVitaeEdit"),
        name: "简历编辑",
      },
      {
        path: "/personalCenter/message",
        component: () => import("@/views/personalCenter/message"),
        name: "消息通知",
      },
      {
        path: "/personalCenter/messageDetail",
        component: () => import("@/views/personalCenter/messageDetail"),
        name: "消息详情",
      },
    ]
  },
  //************************** 隐私协议 **********************************
  {
    path: "/agreement",
    redirect: '/agreement/index/1',
    name: "隐私协议",
    component: Layout,
    children: [
      {
        path: "/agreement/index/:type",
        component: () => import("@/views/agreement/index"),
      },
    ],
  },
  // ************************** 404 **********************************
  { path: '*', redirect: '/404', hidden: true },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
];



// 解决路由重复而报错问题
let originPush = VueRouter.prototype.push
let originReplace = Vue.prototype.originReplace

VueRouter.prototype.push = function (location, res, rej) {
  if (res && rej) {
    originPush.call(this, location, res, rej)
  } else {
    originPush.call(this, location, () => { }, () => { })
  }
}
VueRouter.prototype.replace = function (location, res, rej) {
  if (res && rej) {
    originReplace.call(this, location, res, rej)
  } else {
    originReplace.call(this, location, () => { }, () => { })
  }
}

// const router = new VueRouter({
//   routes,
// });

const createRouter = () => new VueRouter({
  mode: 'history',
  routes: constantRoutes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})


const router = createRouter()
// vue跳转之后页面停留在上一个浏览页面位置不会回到顶部问题
// router.afterEach((to, from, next) => {
//   document.querySelector("body").setAttribute("style", "overflow: auto !important;")
//   window.scrollTo(0, 0)
// });

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router;
